import PageHeader from "../components/layout/PageHeader";
import SectionTitle from "../components/common/SectionTitle";
import { TeamCard } from "../components/common/Cards";
import CtaBanner from "../components/common/CtaBanner";
import { team } from "../data/content";

export default function Team() {
  return (
    <>
      <PageHeader title="Our Team" crumbs={[{ label: "Team" }]} />
      <section className="section">
        <div className="container">
          <SectionTitle
            subtitle="Meet The Team"
            title="The Professionals <span>Driving Us Forward</span>"
            text="Our experienced drivers and dedicated staff are the heart of Taxi24hrs."
          />
          <div className="grid grid-4">
            {team.map((m) => <TeamCard key={m.id} member={m} />)}
          </div>
        </div>
      </section>
      <CtaBanner />
    </>
  );
}
